import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import css from './style.module.scss';

interface IProps {
  icon?: string;
  title?: string;
  minHeight?: 'none';
  children?: ReactNode;
  offset?: '8-0';
  indents?: '24-16';
}

const MessagePlaceholder: FC<IProps> = ({ icon, title, minHeight, children, offset, indents }) => {
  return (
    <div
      className={classNames(css.message__placeholder, {
        [css[`message__placeholder_minHeight_${minHeight}`]]: minHeight,
        [css[`message__placeholder_offset_${offset}`]]: offset,
        [css[`message__placeholder_indents_${indents}`]]: indents,
      })}
    >
      {icon && (
        <div className={css.message__placeholderIcon}>
          <Icon id={icon} />
        </div>
      )}
      {title && <Headline type="secondary">{title}</Headline>}
      {children}
    </div>
  );
};

export default MessagePlaceholder;
